import { render, staticRenderFns } from "./scrollbar.vue?vue&type=template&id=43d0ca47&scoped=true&"
import script from "./scrollbar.vue?vue&type=script&lang=js&"
export * from "./scrollbar.vue?vue&type=script&lang=js&"
import style0 from "./scrollbar.vue?vue&type=style&index=0&id=43d0ca47&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d0ca47",
  null
  
)

export default component.exports